<template>
  <div class="offcanvas-body">
    <LoadingContainer v-if="loading" />
    <div v-html="terms"></div>
  </div>
</template>

<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";
import { settingsRepo } from "@/di/repositories";

const { data: terms, isPending: loading } = useQuery({
  queryKey: ["settings", "terms-of-use"],
  queryFn: () => settingsRepo.getTermsOfUsePsi(),
  staleTime: Infinity,
});
</script>

<style scoped></style>
